import { render, staticRenderFns } from "./CourseMenuForm.vue?vue&type=template&id=3a791062&scoped=true"
import script from "./CourseMenuForm.vue?vue&type=script&lang=js"
export * from "./CourseMenuForm.vue?vue&type=script&lang=js"
import style0 from "./CourseMenuForm.vue?vue&type=style&index=0&id=3a791062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a791062",
  null
  
)

export default component.exports